import { render } from "./ImManagerContact.vue?vue&type=template&id=2049f8c6&scoped=true"
import script from "./ImManagerContact.vue?vue&type=script&lang=js"
export * from "./ImManagerContact.vue?vue&type=script&lang=js"

import "./ImManagerContact.vue?vue&type=style&index=0&id=2049f8c6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2049f8c6"

export default script